import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable, Subject } from 'rxjs'

import { VerityEnvironmentService } from '../../../../environments/verity-environment.service'

@Injectable({
  providedIn: 'root',
})
export class FavoriteService {
  private httpClient = inject(HttpClient)
  private verityEnvironmentService = inject(VerityEnvironmentService)

  public hasUpdated: Subject<boolean> = new Subject<boolean>()

  public setUpdated(sub: boolean): void {
    this.hasUpdated.next(sub)
  }

  public favoriteThreatProfile = (uuid: string): Observable<void> => {
    return this.httpClient.post<void>(
      `${this.verityEnvironmentService.apiUrl}/es/cyborg-threat-profile/${uuid}/favorite`,
      {},
    )
  }

  public unfavoriteThreatProfile = (uuid: string): Observable<void> => {
    return this.httpClient.post<void>(
      `${this.verityEnvironmentService.apiUrl}/es/cyborg-threat-profile/${uuid}/unfavorite`,
      {},
    )
  }

  public favoriteHuntPackage = (uuid: string): Observable<void> => {
    return this.httpClient.post<void>(
      `${this.verityEnvironmentService.apiUrl}/es/cyborg-hunt-package/${uuid}/favorite`,
      {},
    )
  }

  public unfavoriteHuntPackage = (uuid: string): Observable<void> => {
    return this.httpClient.post<void>(
      `${this.verityEnvironmentService.apiUrl}/es/cyborg-hunt-package/${uuid}/unfavorite`,
      {},
    )
  }

  public checkThreatProfileFavorite = (uuid: string): Observable<boolean> => {
    return this.httpClient.get<boolean>(
      `${this.verityEnvironmentService.apiUrl}/es/cyborg-threat-profile/${uuid}/favorite`,
      {},
    )
  }

  public checkHuntPackageFavorite = (uuid: string): Observable<boolean> => {
    return this.httpClient.get<boolean>(
      `${this.verityEnvironmentService.apiUrl}/es/cyborg-hunt-package/${uuid}/favorite`,
      {},
    )
  }
}
